<template>
    <div class="conversation-panel-menu">
        <v-dialog v-model="showConversationDialog" v-if="selectedMenuOption" width="420">
            <v-card>
                <v-card-title class="conversation-panel-menu__delete-title">
                    <h2>{{selectedMenuOption.title}}</h2>
                    <v-btn icon color="ypo_blue"
                           class="conversation-panel-menu__delete-icon"
                           flat
                           data-qe-id="close_dialog_btn"
                           @click="onSelectedMenuCancel">
                        <i class="fas fa-times"></i>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <p v-html="selectedMenuOption.body"></p>
                </v-card-text>
                <v-card-actions class="conversation-panel-menu__actions">
                    <v-btn flat color="ypo_blue" class="bold-font"
                           v-if="selectedMenuOption.cancelButton"
                           data-qe-id="cancel_dialog_btn"
                           @click="onSelectedMenuCancel">
                        {{selectedMenuOption.cancelButton}}
                    </v-btn>
                    <v-btn dark class="primary bold-font"
                           v-if="selectedMenuOption.confirmButton"
                           data-qe-id="save_dialog_btn"
                           @click="onSelectedMenuConfirm">
                        {{selectedMenuOption.confirmButton}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-menu :right="displayRight" :left="!displayRight" class="messenger-menu">
            <v-btn flat icon slot="activator" color="ypo_cta">
                <v-icon>more_vert</v-icon>
            </v-btn>
            <v-list class="messenger-menu__list">
                <v-list-tile v-for="menuItem in menuOptions"
                             :key="menuItem.key"
                             :data-qe-id="menuItem.key"
                             @click="handleSelection(menuItem)"
                             v-if="menuItem.isVisible"
                             clsss="messenger-menu__list-item">
                    <v-list-tile-title>{{menuItem.label}}</v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import { storeAction } from "../../../store/storeActions.constant";
    import { isValidConversationId, isGroupConversation, canEditConversation } from "../iam.utils";
    import { appCommonConstants } from "../../appCommon.constants";
    import {
        groupConversationMenu,
        iamConstants,
        oneOnOneConversationMenu,
    } from "../iam.constant";
    import { storeGetters } from "../../../store/storeGetters.constant";
    import { appConstant } from "../../../app.constant";

    export default {
        name: 'ConversationPanelMenu',
        props: {
            conversation: {
                type: Object,
                required: true,
            },
            onDeleted: {
                type: Function,
                required: false,
            },
            onManageGroup: {
                type: Function,
            },
            onRenameAction: {
                type: Function,
            },
            displayRight: {
                type: Boolean,
            },
        },
        data() {
            return {
                appCommonConstants,
                iamConstants,
                showConversationDialog: false,
                selectedMenuOption: null,
            };
        },
        methods: {
            ...mapActions('messenger', {
                sendMessage: storeAction.sendMessage,
                deleteConversation: storeAction.deleteConversation,
                removeConnection: storeAction.removeConnection,
            }),
            handleSelection(menuItem) {
                if (menuItem && menuItem.clickHandler) {
                    this[menuItem.clickHandler](menuItem);
                }
            },
            onSelectedMenuConfirm() {
                if (this.selectedMenuOption) {
                    this[this.selectedMenuOption.onConfirm]();
                }
            },
            onSelectedMenuCancel() {
                if (this.selectedMenuOption) {
                    this[this.selectedMenuOption.onCancel]();
                }
            },
            setSelectedMenuOption(menuItem) {
                if (!isValidConversationId(this.conversation.id)) {
                    return;
                }
                if (menuItem.actionData) {
                    this.selectedMenuOption = menuItem.actionData;
                    this.showConversationDialog = true;
                }
            },
            confirmDeleteConversation() {
                this.deleteConversation({ conversationId: this.conversation.id }).then(() => {
                    this.showConversationDialog = false;
                    if (this.onDeleted) this.onDeleted();
                });
            },
            confirmRemoveConnection() {
                this.removeConnection(this.conversation);
            },
            cancelDialogAction() {
                this.showConversationDialog = false;
            },
            manageGroup() {
                this.onManageGroup(this.conversation);
            },
            handleRenameGroup() {
                this.onRenameAction();
            },
            launchPnP() {
                window.open(appConstant.POLICY_AND_PROCEDURE_LINK, '_blank');
            },
        },
        computed: {
            ...mapGetters('messenger', {
                messengerUsername: storeGetters.messengerUsername,
            }),
            menuOptions() {
                let options = [];
                if (this.conversation) {
                    if (isGroupConversation(this.conversation)) {
                        const canEdit = canEditConversation(this.conversation);
                        options = groupConversationMenu(canEdit, this.onManageGroup, this.onRenameAction);
                    } else {
                        options = oneOnOneConversationMenu(this.conversation, this.messengerUsername);
                    }
                }
                return options;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';

    .conversation-panel-menu {

        &__actions {
            padding: 0 20px 10px 0 !important;
            justify-content: flex-end;
        }

        &__delete {
            &-title {
                background-color: $ypo-tile-border;
                color: $ypo-blue;
            }

            &-icon {
                position: absolute;
                right: 0;
            }
        }
    }
</style>

